<pdf-viewer [src]="value" [render-text]="true" [original-size]="false" (error)="onError($event)"
    [style]="style" (after-load-complete)="onLoaded($event)">
</pdf-viewer>
